// extracted by mini-css-extract-plugin
export default {"box":"cancellationPage_box__8DLNY"};